export default {"src":"/_next/static/media/linkedin.9a3844b3.svg","height":12,"width":13};